import React, {Component} from 'react';
import {DownloadTextStyled} from "./styled";
import JsPDF from 'jspdf';
import PdfValidationReportPage from "./PdfValidationReportPage";
import {ValidationReportContext} from "../../../Contexts/ValidationReportContext";
import {TableCell, TableRow} from "@material-ui/core";
import DateUtil from "../../../Utils/DateUtil";


class Recibo extends Component {
    constructor(props) {
        super(props);

    }

    getData = async () => {

        const value = this.props.value;

        const sendObject = {
            type: value.award.title,
            created_at: DateUtil.raw(value.created_at).toDateTime24(),
            fantasy_name: value.company.fantasy_name,
            validated_by: value.validated_by.name,
            difff: value.original_amount !== value.received_amount ? 'Sim' : 'Não',
            original_amount: value.original_amount,
            received_amount: value.received_amount,
        };

        console.log(PdfValidationReportPage.ROUTE + `/${JSON.stringify(sendObject)}`);

        window.open(PdfValidationReportPage.ROUTE + `?value=${JSON.stringify(sendObject)}`, '_blank');
    }

    render() {
        return (
            <div>
                <DownloadTextStyled variant={'button'}
                                    onClick={() => this.getData()}>
                    Recibo
                </DownloadTextStyled>
            </div>
        );
    }
}

export default Recibo;